export const qaRowClassName = ({ POID }) => `qa_${POID}`;
